
import Vue from 'vue';
import TextInput from '../Input/Input.vue';
import { Row } from '../Grid';
import { Spacer } from '../Spacings';

export default Vue.extend<any, any, any, any>({
  components: {
    TextInput,
    Row,
    Spacer
  },
  inheritAttrs: false,
  props: {
    variant: {
      type: String,
      default: 'base'
    },
    label: {
      type: String,
      default: null
    },
    error: {
      type: Boolean,
      default: false
    },
    leftInfo: {
      type: String,
      default: ''
    },
    rightInfo: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    leftIcon: {
      default: ''
    },
    searchIcon: {
      default: ''
    },
    search: {
      type: Function,
      default: () => {}
    },
    border: {
      type: Boolean,
      default: false
    },
    additionField: {
      type: Boolean,
      default: false
    },
    additionFieldValue: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      focus: false
    };
  },
  computed: {
    isFocus() {
      return this.focus || !!this.value;
    },
    getPlaceholder() {
      if (this.variant === 'base') {
        // Return null if label is defined
        return this.$attrs.placeholder ? null : this.$attrs.placeholder;
      }
      return this.$attrs.placeholder;
    },
    getLabel() {
      const inputLabel = this.label || this.$attrs.placeholder;
      if (this.variant === 'base' && !this.leftIcon) {
        // Return null if label is defined
        return this.$attrs.placeholder ? inputLabel : this.$attrs.placeholder;
      }
      return this.label || this.$attrs.placeholder;
    }
  },
  methods: {
    handleChange(e: Event) {
      this.$emit('input', (e.target as HTMLInputElement).value);
    },
    handleFocus() {
      this.focus = true;
    },
    handleBlur() {
      this.focus = false;
    }
  }
});
